export default {
    primary: '#4A5567',
    secondary: '#FFFFFF',
    accent: '#E9E9E9',
    accentDarker: '#4b4a4a',
    danger: '#C62827',
    warning: '#E3DB18',
    success: '#32C040',
    black: '#333333',
};